import React, { Component } from 'react';
import { connect } from 'react-redux';
import MANUALFORSMS from '../tutorials/Vendor_Portal_Manual.pdf'
import MANUALFORVENDOR from '../tutorials/Vendor_Portal_Manual_Vendor.pdf'
import authInstance from '../Classes/AuthHandler';

class Manualdownload extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        var roles = authInstance.getRoles()
        return (
            <div className="container" style={{ marginBottom: '3%' }}>
                <h2 className="text-center pt-2">MANUALS</h2>
                {roles[5] ?
                    <object data={MANUALFORVENDOR} type="application/pdf"
                        width="100%" height="100%" style={{ minHeight: "1000px" }}
                    ></object>
                    : <object data={MANUALFORSMS} type="application/pdf"
                        width="100%" height="100%" style={{ minHeight: "1000px" }}
                    ></object>
                }

            </div>


        )

    }
}
const mapStateToProps = (state) => ({})
export default connect(mapStateToProps, {})(Manualdownload)